import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Calls" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_leads_filters = _resolveComponent("leads-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_leads_filters, {
      onReset: _ctx.resetFilters,
      onSearch: _ctx.applyFilters
    }, null, 8, ["onReset", "onSearch"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.data_state.leads.is_failed && !_ctx.data_state.leads.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.data_state.leads.is_loading,
            text: "При получении списка произошла ошибка",
            "error-message": _ctx.data_state.leads.failure.error_state.message,
            "error-url": _ctx.data_state.leads.failure.error_state.url,
            "error-status": _ctx.data_state.leads.failure.error_state.status,
            onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadLeads(_ctx.data_state.leads.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 1,
            loading: _ctx.data_state.leads.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.data_state.leads.is_loading,
                columns: _ctx.LeadsColumns,
                rows: _ctx.data_state.leads.list,
                "with-limit": "",
                "pagination-limit": _ctx.filters_state.limit,
                "pagination-total-items": _ctx.data_state.leads.pagination.total_items,
                "pagination-current-page": _ctx.data_state.leads.pagination.current_page,
                "pagination-total-pages": _ctx.data_state.leads.pagination.total_pages,
                onChangePage: _ctx.loadLeads,
                onChangeLimit: _ctx.onLimitChange
              }, {
                buttons: _withCtx(() => [
                  _createVNode(_component_the_button, {
                    class: "primary text small mr-3",
                    onClick: _ctx.exportExcel,
                    loading: _ctx.excel_state.is_loading,
                    hint: "Скачать в Excel"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading"])
                ]),
                td: _withCtx(({ row, column }) => [
                  (column.key === 'id')
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: `/preferences/leads/${row.id}`,
                        class: "text-blue-500",
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.id), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (column.key === 'createdAt')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatDate(row[column.key])), 1)
                        ], 64))
                      : (column.key === 'comment')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(_ctx.cut(row.comment, 50)), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                          ], 64))
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
            ]),
            _: 1
          }, 8, ["loading"]))
    ])
  ]))
}